import { useRoleText } from '@melio/ap-domain';
import { Badge, Table } from '@melio/penny';
import { Collaborator } from '@melio/platform-api';

type Props = { collaborator: Collaborator<'user'> };
export const RoleCell = ({ collaborator }: Props) => {
  const { getRoleText } = useRoleText();

  return (
    <Table.Cell data-testid={`collaborators-table-row-${collaborator.id}-role-cell`}>
      <Badge type="primary" status="neutral" label={getRoleText(collaborator.roleUniqueName)} />
    </Table.Cell>
  );
};
